/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { TransportList01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const transportList01ResetTimestamp = (
  state,
  { currentPage, sorts, filters, pageSize }
) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  selectedResources: INITIAL_STATE.selectedResources,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const transportList01FetchTransportList01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const transportList01FetchTransportList01Success = (
  state,
  { resources, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  resources,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const transportList01AddSelectedResources = (state, { selectedResources }) => {
  const selectIds = state.selectedResources.map(value => value.id);
  return {
    ...state,
    selectedResources: [
      ...state.selectedResources,
      ...selectedResources.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const transportList01RemoveSelectedResources = (state, { selectedResources }) => {
  const selectIds = selectedResources.map(value => value.id);
  return {
    ...state,
    selectedResources: state.selectedResources.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const transportList01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [TransportList01Types.TRANSPORT_LIST01_RESET_TIMESTAMP]: transportList01ResetTimestamp,
  [TransportList01Types.TRANSPORT_LIST01_FETCH_TRANSPORT_LIST01_LOADING]: transportList01FetchTransportList01Loading,
  [TransportList01Types.TRANSPORT_LIST01_FETCH_TRANSPORT_LIST01_SUCCESS]: transportList01FetchTransportList01Success,
  [TransportList01Types.TRANSPORT_LIST01_ADD_SELECTED_RESOURCES]: transportList01AddSelectedResources,
  [TransportList01Types.TRANSPORT_LIST01_REMOVE_SELECTED_RESOURCES]: transportList01RemoveSelectedResources,
  [TransportList01Types.TRANSPORT_LIST01_SET_WORKSPACE_VISIBLE]: transportList01SetWorkspaceVisible
});
